"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRocket16 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ transform: "translate(0 .5)", fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "none", width: 16, height: 16, rx: 1 }), (0, jsx_runtime_1.jsx)("path", { d: "m9.355 3.997 2.638 2.638M8.32 4.571a3.55 3.55 0 0 0-3.916.75 3.544 3.544 0 0 0-.544.71l1.52 1.52m6.043.106a3.55 3.55 0 0 1-1.453 4.484l-1.528-1.527m-1.214.668-2.51-2.51s2.144-5.333 8.157-5.647c-.34 5.987-5.647 8.157-5.647 8.157Zm-2.418.862c-.334.334-1.674.465-1.674.465s.13-1.34.464-1.675a.855.855 0 1 1 1.21 1.21ZM8.65 8a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3Z", strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor" })] })) }))); };
exports.default = SvgRocket16;
